import { useState, useEffect } from 'react';

export const APP_STORE_URL = 'https://apps.apple.com/us/app/outclose-make-gay-friends-irl/id6758222456';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.outclose.app';

declare global {
  interface Window {
    AF_SMART_SCRIPT_RESULT?: { clickURL?: string };
  }
}

/**
 * Polls for the AppsFlyer Smart Script result (injected via GTM) and
 * returns the attributed clickURL once available, or null while loading.
 */
export function useAppsFlyerClickUrl(): string | null {
  const [clickUrl, setClickUrl] = useState<string | null>(
    () => window.AF_SMART_SCRIPT_RESULT?.clickURL ?? null,
  );

  useEffect(() => {
    if (clickUrl) return;

    let attempts = 0;
    const MAX_ATTEMPTS = 20;
    const timer = setInterval(() => {
      const url = window.AF_SMART_SCRIPT_RESULT?.clickURL;
      if (url) {
        setClickUrl(url);
        clearInterval(timer);
      } else if (++attempts >= MAX_ATTEMPTS) {
        clearInterval(timer);
      }
    }, 500);

    return () => clearInterval(timer);
  }, [clickUrl]);

  return clickUrl;
}
